// API Configuration
const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || 'https://grace-fellowship-analytics-backend-staging.jeremy-caf.workers.dev';

export const apiConfig = {
  baseURL: API_BASE_URL,
  endpoints: {
    auth: {
      login: '/api/auth/login',
      verify: '/api/auth/verify',
      logout: '/api/auth/logout'
    },
    analytics: {
      summary: '/api/analytics/summary',
      memberJourney: '/api/analytics/member-journey',
      advanced: '/api/analytics/advanced',
      geographic: '/api/analytics/geographic',
      leadership: '/api/analytics/leadership',
      contactCompleteness: '/api/analytics/contact-completeness'
    },
    workflows: {
      analytics: '/api/workflows/analytics'
    },
    people: {
      activityFeed: '/api/people/activity-feed'
    },
    users: {
      list: '/api/users',
      roles: '/api/users/roles',
      create: '/api/users',
      update: (id: string) => `/api/users/${id}`,
      delete: (id: string) => `/api/users/${id}`
    },
    journeyStages: {
      configurations: '/api/journey-stages/configurations',
      active: '/api/journey-stages/configurations/active',
      activate: (id: string) => `/api/journey-stages/configurations/${id}/activate`,
      update: (id: string) => `/api/journey-stages/configurations/${id}`,
      delete: (id: string) => `/api/journey-stages/configurations/${id}`
    },
    memberDetails: {
      get: (id: string) => `/api/member-details/${id}`
    },
    password: {
      change: '/api/password/change-password'
    },
    admin: {
      membershipMaintenance: '/api/admin/membership-maintenance',
      exportMembershipRecommendations: '/api/admin/export-membership-recommendations',
      membershipCriteria: '/api/admin/membership-criteria'
    }
  }
};

export const buildApiUrl = (endpoint: string) => `${API_BASE_URL}${endpoint}`;
